<template>
    <div class="container-fluid" >
        <nav aria-label="breadcrumb" class="col-sm-12">
            <ol class="breadcrumb bg-orange mb-0">
                <li class="breadcrumb-item"><a href="/" class="text-white"><i class="ri-home-4-line mr-1 float-left" style="font-size: 20px"></i>News</a></li>            </ol>
        </nav>    
        <br>
        <div class="container-fluid" style="display: flex;">
        <b-col md="7" class="float-left"  style=" margin-right: 170px;">
            <h4><strong>{{newsForm.title}}</strong></h4>
            <br>
            <div >
                <img :src="newsForm.image" width="100%">
            </div>
            <br>
            <h5>{{newsForm.short_description}}</h5>
            <br>
            <div class="justify-center">
                <p v-bind:style="{width : 'auto', 'text-align': 'justify', 'white-space': 'pre-wrap'}" >{{ newsForm.long_description }}</p>
            </div>
            <br>
            <div class="row justify-content-center" v-show="showCountdown">
                <div class="col-sm-9 text-center">
                <div class="iq-comingsoon-info">
                    <h5>Time Left: </h5>
                    <ul class="countdown d-flex align-items-center list-inline" id="clockdiv" :data-date="newsForm.end_date">
                    <li class="col-md-6 col-lg-3">
                        <div class="iq-card">
                        <div class="iq-card-body">
                            <span data-days>0</span>Days
                        </div>
                        </div>
                    </li>
                    <li class="col-md-6 col-lg-3">
                        <div class="iq-card">
                        <div class="iq-card-body">
                            <span data-hours>0</span>Hours
                        </div>
                        </div>
                    </li>
                    <li class="col-md-6 col-lg-3">
                        <div class="iq-card">
                        <div class="iq-card-body">
                            <span data-minutes>0</span>Minutes
                        </div>
                        </div>
                    </li>
                    <li class="col-md-6 col-lg-3">
                        <div class="iq-card">
                        <div class="iq-card-body">
                            <span data-seconds>0</span>Seconds
                        </div>
                        </div>
                    </li>
                    </ul>
                </div>
                </div>
        </div>
        </b-col>
       

        <div class="news-sidebar col-md-3 justify-content-center" >
                    <div class="card iq-mb-3"  v-for="item in allGame" v-bind:key="item.id">
                        <div class="card-body game-info">
                                <b-card-text class="text-center">
                                    <strong>{{item.name}} </strong>
                                    <b-card-img :src="getImgUrl(item.code)" style="width: 70%; "></b-card-img>

                                </b-card-text>
                                <b-card-text style="text-align: justify;">
                                    <strong>RTP</strong> {{item.rtp}}
                                </b-card-text>
                                <h6>{{item.start_date}}</h6>
                                <b-button v-bind:href="'/'+item.category+'/game-detail?code='+ item.code"  block variant="primary">Go</b-button>    

                        </div>
                    </div>
                    <div class="card iq-mb-4"  v-for="item in newsUpcoming" v-bind:key="item.id">
                        <div class="card-header bg-dark">Upcoming News</div>
                        <div class="card-body bg-light">
                                <b-card-text>
                                    <strong>{{item.title}} </strong>
                                </b-card-text>
                                <b-card-text style="text-align: justify;">
                                    {{item.short_description  | truncate(70, '...')}}
                                </b-card-text>
                                <h6>{{item.start_date}}</h6>
                                <b-button v-bind:href="'/news/detail?id='+ item.id"  block variant="primary">Go</b-button>    
                        </div>
                    </div>

                    <div class="card iq-mb-4"  v-for="item in latestRelease" v-bind:key="item.id">
                        <div class="card-header bg-dark">Latest Release</div>
                        <div class="card-body bg-light">
                                <b-card-text>
                                    <strong>{{item.name}} </strong>
                                </b-card-text>
                                <b-card-text style="text-align: justify;">
                                    {{item.shortDesc | truncate(150, '...')}}
                                </b-card-text>
                                <h6>{{item.releaseDate}}</h6>
                                <b-button v-bind:href="'/'+item.category+'/game-detail?code='+ item.code" block variant="primary">Go</b-button>    
                        </div>
                    </div>

                    <div class="card iq-mb-4"  v-for="item in promoUpcoming" v-bind:key="item.id">
                        <div class="card-header bg-dark">Upcoming Promo</div>
                        <div class="card-body bg-light">
                                <b-card-text>
                                    <strong>{{item.title}} </strong>
                                </b-card-text>
                                <b-card-text style="text-align: justify;">
                                    {{item.short_description  | truncate(150, '...')}}
                                </b-card-text>
                                <h6>{{item.start_date}}</h6>
                                <b-button v-bind:href="'/slots/game-detail?code='+ item.code" block variant="primary">Go</b-button>    
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .iq-mb-3{
         /* box-shadow: 5px 10px; */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        text-align: center;
    }

    .card{
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }
    h5{
        text-align: justify;
    }
   
</style>

<script>
import axios from 'axios';
import moment from 'moment';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import { core } from '../../../../config/pluginInit';

const coundown = () => import('../../../../assets/js/countdown.js')
const config = require("../../../../../config");

Vue.use(VueAxios, axios, moment)

export default {
    name:'NewsDetail',
    data() {
        return{
            newsForm:[],
            newsUpcoming: [],
            latestRelease:[],
            promoUpcoming:[],
            allGame:[],
            showCountdown: true
        }
    },
    async mounted() {
        try {
            let id = this.$route.query.id
            var filter = function(text, length, clamp){ 
                clamp = clamp || '...';
                var node = document.createElement('div');
                node.innerHTML = text;
                var content = node.textContent;
                return content.length > length ? content.slice(0, length) + clamp : content;
            };

            Vue.filter('truncate', filter);
            
            const res = await axios.get(config.api.URL + '/api/news/detail', {
                params: {
                    m: this.$route.meta.uid,
                    id: id
                }
            });
            
            this.newsForm = res.data.news_detail
            this.newsForm.image = config.api.URL +  res.data.news_detail.image

            if (this.newsForm.countdown === "no" || !this.newsForm.countdown) {
                this.showCountdown = false
            }
            
             /*latest game release checking */
            var games = res.data.latest_game
            games.forEach(element => {
                if (element.code === this.newsForm.game_code) {
                    if (element.category == 'SLOT') {
                        element.category = 'slots'
                    } else {
                        element.category.toLowerCase()
                    }
                    this.allGame.push(element)
                }
            });

            this.latestRelease.push(res.data.latest_game[0])

            /*upcoming news checking */
            const dates = []
            res.data.news_latest.forEach(element => {
                var releaseDate = moment(element.start_date).format("YYYY/M/DD");
                var currDate = this.currentDate()
                var date2Obj = new Date(releaseDate)
                var cur2Obj = new Date(currDate)

                var before = moment(date2Obj).isBefore(moment(cur2Obj).format("YYYY/MM/DD"))
                var same = moment(date2Obj).isSame(moment(cur2Obj).format("YYYY/MM/DD"))

                element.image = config.api.URL + element.image

                if(before === false && same === false && element.category !== "PROMO"){
                    dates.push(moment(date2Obj))
                    this.newsUpcoming.push(element)
                }

                if(element.category === "PROMO"){
                        if(before === false && same === false){
                        this.promoUpcoming.push(element)
                    }
                }     
            });

            var minDate = new Date(Math.min.apply(null, dates));
           
            this.newsUpcoming.forEach(element => {
                console.log(moment(element.start_date).isSame(moment(minDate).format("YYYY/MM/DD")))
                if (moment(element.start_date).isSame(moment(minDate).format("YYYY/MM/DD"))) {
                    this.newsUpcoming = []
                    this.newsUpcoming.push(element)
                }             
            });

            coundown()
            core.index()

        } catch (error) {
            alert("Data retrieve error.");
            console.log("Error: ", error);
        }
    },

    methods: {
         currentDate() {
            const current = new Date();
            const date = `${current.getFullYear()}/${current.getMonth()+1}/${current.getDate()}`;
            return date;
        },
        getImgUrl(gameCode) {
            try {
                return require('../../../../../static/images/gamepic/'+gameCode+'_193x205.png');
            } catch (error) {
                return require('../../../../assets/images/NS_Black_cleaned.svg');
            }
        }

    },

    destroyed(){
        core.index()
    }
    
}
</script>